import { getCmsAuthorizationHeaderObject, getCmsUrl, getDeepTranslationsFilter } from "@/services/cms";
import { httpClient } from "@/services/http";
import { LocaleCode } from "@/services/i18n";

import { getHeaderResponseSchema } from "./get-header.schema";
import type { GetHeaderRequestProps } from "./get-header.types";

export const GET_HEADER_ENDPOINT = "/items/header";

export const getHeaderRequest = async ({ locale }: GetHeaderRequestProps) => {
  const response = await httpClient.get(getCmsUrl(GET_HEADER_ENDPOINT), {
    headers: getCmsAuthorizationHeaderObject(),
    params: {
      deep: {
        ...getDeepTranslationsFilter(LocaleCode.fromLocale(locale)),
      },
      fields: ["translations.links"],
    },
    next: {
      tags: ["header"],
      revalidate: false,
    },
    queryOptions: { arrayFormat: "comma" },
  });

  return getHeaderResponseSchema.parse(response);
};
